export function toTitleCaseName(value: string) {
  const normalizedValue = value
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();

  if (!normalizedValue) {
    return "";
  }

  return normalizedValue.replace(
    /(^|[\s./'-])([a-z])/g,
    (_, prefix: string, character: string) => `${prefix}${character.toUpperCase()}`,
  );
}
